module.exports = __webpack_public_path__ + "img/ShadowShaman.45ed7b5d.png";